<template>
  <b-card no-body class="h-100">
    <b-card-header>
      <h4 class="card-title">Previsão de Atraso das Operações</h4>
    </b-card-header>
    <b-card-body class="d-flex flex-column justify-content-center align-items-center">
      <div class="radial-chart-wrapper">
        <vue-apex-charts type="radialBar" height="200" :options="chartOptions" :series="series" />
      </div>
      <div class="d-flex justify-content-between w-100 mt-2 text-center">
        <div class="stat-item">
          <div class="text-muted mb-1">Ordens a Atrasar</div>
          <h4 class="font-weight-bolder">{{ data.ordersToDelay }}</h4>
        </div>
        <div class="stat-item border-left pl-2">
          <div class="text-muted mb-1">Total de Ordens</div>
          <h4 class="font-weight-bolder">{{ data.totalOrders }}</h4>
        </div>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardHeader, BCardBody } from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    VueApexCharts
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      series: [this.data.percentage],
      chartOptions: {
        chart: {
          sparkline: {
            enabled: true
          }
        },
        colors: ['#2d3748'], // Dark color from image
        plotOptions: {
          radialBar: {
            hollow: {
              size: '65%'
            },
            track: {
              background: '#e2e8f0'
            },
            dataLabels: {
              show: true,
              name: {
                show: false
              },
              value: {
                fontSize: '2rem',
                color: '#5e5873',
                offsetY: 10,
                formatter: function (val) {
                  return val + '%'
                }
              }
            }
          }
        },
        stroke: {
          lineCap: 'round'
        }
      }
    }
  },
  watch: {
    data: {
      handler(newVal) {
        this.series = [newVal.percentage]
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.stat-item {
  flex: 1;
}
</style>
